console.log("%c"+'\n'
+"                                                                                                   '                                           '                                             "+'\n'
+"                                                                                               '             '                                                             )`·.          "+'\n'
+"                  /(      .·´( )`·.                          (`·.                )\\            '            (`·.               )\\'                             /(      .·´    (          "+'\n'
+"          )\\      )  `·._):::.....::)         '’               )  `·.   .·´( .·´  (     /(     '             )  `·.   .·´( .·´  (     /('             )\\      )  `·._):::.    )        '’"+'\n'
+"    )\\ .·´ .:`·.(:;;  --  ' '\\:. :(.·´)    )\\           .·´( .·´:..::(,(::--  ’ \\::.`·._) `·.        .·´( .·´:..::(,(::--  ' '\\::.`·._) `·.’    )\\ .·´ .:`·.(:;;  --  ' '\\:. :(.·´)    )\\ "+'\n'
+".·´  (,): --  ' '              \\....:::`·./:.:\\)`·.     );; :--  ' '             _\\::....:::::)’(     );; :--   '               \\::....:::::).·´  (,): --  ' '              \\....:::`·.(  ("+'\n'
+"):.::/\\                 ,..::´/:::......::::·´.::(  .·´/\\                ,..:´:::::'/ `  · :/;·´  .·´/\\                ,...__ ¯¯¯` ·:·´’):.::/\\                        ¯¯¯` · ::·´’"+'\n'
+"`·:/::::\\...:´/       /:::::/¯¯¯¯/:::/¯¯¯¯/   )/:::'\\...:´/       /::::::::::/        /     )/:::'\\...:´/       /:::::::::::/     /   `·:/::::\\...:´/       ____          \\     "+'\n'
+"   \\::::/::::/      /;::·´'/       / ·:/       / '    \\:::/::::/       /;;:::·  ´ /        '/       \\:::/::::/       /;;::;;´-··´´     /  '  \\::::/::::/      /::::::::/I        /    ’'"+'\n'
+"     \\/;::-'/      /     '/       /   /       /        '\\/;::-'/       /,  -·· ' '          /     '    '\\/;::-'/               ,...::::´/     '   \\/;::-'/      /::::::::/:/       /'      "+'\n'
+"          /      /     '/       /   /       /  '            /        ,...-:::: ´'/       '/   '            /       ,, -,      \\::::::/    '             /      /¯¯¯¯¯'I/        /''       "+'\n'
+"        '/      /     '/       /   /       /         .·´( '/       /::::::::::::/       '/   '      .·´( '/       /:::/::\\      \\:· ´                 '/      /       /        /         '"+'\n'
+"       /I      'I    '/       /   /       /   '     _) ::/____/;;::::: - ´/        /      ’  _) ::/       '/;;:/::::'\\      '\\          ’'       /I     'I      /        /'      '    "+'\n'
+"     /:/::·.,   `·,/        `·,/       /          `·:::/:::::::/.  - ··  ´´       .·´/    '     )..::/       /    '\\::::::'\\      '\\              /::/`· ,   `·,_'/       /’            "+'\n'
+"    I/:::::::::*·.___ .·:/:·._..-:´/              )/::; - '          ..-:::::'/:::/       '   `·:/___/       '\\::::::\\____\\           I:/::::::::` · ,___,.·:/'             '"+'\n'
+"     `·-:;::::::/:::::/::/:::'/:/::::/       '         ¯/::`*..¸..-::::::::::::/:·´            ' /::::::::/           '\\::::/:::::::/            `·:;::::::::::/:::::/:::/'      '    "+'\n'    
+"           '*·:/:::::/:·´ *·:/:/::-·´                 /:::::::/::::::::::-·· ´´               ' /::::::::/              '\\/:::::::'/     '             ` ·:;:::/:::::/;·´'             '   "+'\n'
+"               ¯¯¯         ¯                       `*-::;/::::-·· '’                         ¯¯¯¯¯                 ¯¯¯¯          ’                 ¯¯¯ ’                     "+'\n',"background-color:#fff;color:#335dc1;font-family:sans-serif")

var RootView = Marionette.View.extend({
    template:"#tmpl-site-root"
    ,regions: function() {
        return {
            systemMessagesRegion 	: "#system-messages-region"
           ,mainRegion				: "#main-region"
           //,navRegion				: "#nav-region"
           ,dialogRegion			: "#dialog-region"
           ,ribbonRegion			: "#ribbonRegion"
           ,modalRegion             : "#modalRegion"
        };
    }
    ,events:{
        "keypress #headerSearch":function(e){
	        if(e.which===13){
		        var term = $('#headerSearch').val().trim().replace(/[^\w\s-]/gi,'');
				if(term){ window.location.href="/search/"+term; }
			}
        }
    }
    ,onAttach:function(){
	    this.showChildView('ribbonRegion',Backbone.Radio.channel('views').request('ribbon-pledge'))
        this.showChildView('modalRegion',Backbone.Radio.channel('views').request('modalRegion'))
    }
});

var APP = new Marionette.Application({
     region:'#root'
    //could also use APP.on("start",function(){})
    ,onStart:function(){
        console.log("APP Start")
        this.showView(new RootView())
        
        if(!Backbone.history.start({pushState: true})){
            //throw a 404 if you want
            Backbone.Radio.channel('404').request("show");
        }
    }
});

